import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { Button } from '@nextui-org/react'
import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="flex h-[60vh] items-center justify-center" role="alert">
      <div className="text-center">
        <ExclamationTriangleIcon
          aria-hidden="true"
          className="mx-auto h-12 w-12 text-warning"
        />
        <h1 className="mt-4 text-2xl font-bold">404 Not Found</h1>
        <p className="mt-2 text-default-600">
          Sorry, the page you are looking for could not be found.
        </p>
        <Button
          as={Link}
          className="mt-8 uppercase"
          color="primary"
          to="/"
          variant="solid"
        >
          Back to homepage
        </Button>
      </div>
    </div>
  )
}

export default NotFound
